import React from "react";
import "./ViewContainer.css";

export default function ViewContainer({
  children,
  gap = "md",
  as: Component = "div",
  className = "",
  ...props
}) {
  return (
    <Component
      className={["view-container", `view-container--${gap}`, className]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </Component>
  );
}
